export default __webpack_public_path__ + "scripts/resources/assignments/en/colligative/bp_elevation/spectra.json";